module.exports = __webpack_public_path__ + "img/error-conn.e6edcdc3.png";